import { ConfigProvider } from 'antd';
import React, { useEffect, useState } from 'react';

const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [primaryColor, setPrimaryColor] = useState<string>('');

  useEffect(() => {
    const rootStyles = getComputedStyle(document.documentElement);
    const primaryBase = rootStyles.getPropertyValue('--primary-base').trim();
    setPrimaryColor(primaryBase);
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: primaryColor,
        },
        components: {
          Input: {},
          Modal: {
            borderRadiusLG: 20,
          },
          Popover: {
            borderRadiusLG: 10,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default ThemeProvider;
